export default __webpack_public_path__ + "static/media/Bjorn_S.6fa0a783.png";